export default __webpack_public_path__ + "static/media/automated-logistics.021357d7.png";